'use client';

export default function Error({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-light font-display">
      <div className="text-center">
        <h1 className="text-5xl font-bold text-text-primary">Something went wrong</h1>
        <p className="mt-4 text-lg text-text-muted">
          We couldn&apos;t load this page. Please try again.
        </p>
        <button
          onClick={reset}
          className="mt-6 inline-block bg-primary text-white px-8 py-3 rounded-full font-bold hover:bg-primary-dark transition-colors"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
